import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Hover = ({ size, color, theme, iconTitle }) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      viewBox="0 0 14 14"
      width={size}
      height={size}
      color={iconColor}
      fill={iconColor}
    >
      <title>{iconTitle}</title>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#A28352" stroke-width="2" cx="7" cy="7" r="6"></circle>
      </g>
    </svg>
  );
};

Hover.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Hover.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Hover);
